import { AuthContext } from "@/Context/AuthContext";
import { useContext } from "react";

export const useAuth = () => useContext(AuthContext);